module.exports = "//public.getcloudapp.com/packs/media/images/hero-asset-92341528ee75add08ae9be43666a8588.gif";